import {useEffect, useState} from "react";
import {getValueOrDash} from "../../../helpers/defaultReturnFunction";
import {standardDate} from "../../../manager/dateManager";
import {dateType} from "./fields";

const editableColumns = ["Qty", "DueDate", "RatePerUnit"];

const EditableCell = ({
  value: initialValue,
  row: {index},
  column: {id},
  updateLocalState,
}) => {
  const [value, setValue] = useState(initialValue);

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const onBlur = () => {
    setValue(initialValue);
    updateLocalState(index, id, value);
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  if (editableColumns.includes(id)) {
    if (dateType.includes(id)) {
      return (
        <input
          className="table-input"
          type="date"
          value={standardDate(value)}
          onChange={onChange}
          onBlur={onBlur}
        />
      );
    }
    return (
      <input
        className="table-input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        style={{fontSize:"10px"}}
      />
    );
  } else return `${getValueOrDash(value)}`;
};

export const poUpdateEditableCell = {
  Cell: EditableCell,
};
